import { REGISTER_TOKENCA } from 'redux/actions';
import { IAction, IRegisterCA } from 'interfaces/common';
import { call, put, takeLatest } from 'redux-saga/effects';
import { Global } from 'constants/main';
import {
  signTokenCA,
  registerTokenCA as saveSignTokenCA,
} from '../../../utils/signTokenCA';
import { addHours } from 'date-fns';
import {
  ISignTokenCAResponse,
  ISaveSignTokenCAResponse,
} from 'interfaces/api'

const registerTokenCA = (payload: IRegisterCA): Promise<Response> | null => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Global.sockets.wts?.authToken?.accessToken}`,
    },
    body: JSON.stringify(payload),
  };

  return fetch(
    `/kgw/cavault/v1/ca`, 
    requestOptions
  )
    .then((res) => {
      return res.json();
    })
    .catch((error) => {
      console.error('Error Register Token CA:', error);
    });
};

function* doRegisterTokenCA(request: IAction<IRegisterCA>) {
  let responseRegisterTokenCA: {
    error?: string;
    message?: string;
    status?: number;
  };

  try {
    responseRegisterTokenCA = yield call(registerTokenCA, request.payload);
    if (responseRegisterTokenCA && responseRegisterTokenCA?.status !== 201) {
      yield put({
        type: request.response?.failed,
        payload: responseRegisterTokenCA,
      });
    } else {
      const data = {
        action: 'register',
        serialToken: request.payload.serialToken,
        dataSign: {
          clientID: request.payload.clientID,
        },
        timeSign: new Date(),
      };

      const responseSign: ISignTokenCAResponse = yield call(
        signTokenCA,
        request.payload.serialToken ?? '',
        data
      );
      if (responseSign && responseSign.code == 1) {
        let dataSubmit = {
          dataSignTokenCA: responseSign.data,
          ...data,
        };

        const responseSaveSignTokenCA: ISaveSignTokenCAResponse = yield call(saveSignTokenCA, {
          action: 'register',
          serialToken: request.payload.serialToken ?? '',
          dataSign: JSON.stringify(dataSubmit),
          timeSign: addHours(new Date(), 7).toISOString() ?? '',
        });

        if (responseSaveSignTokenCA && responseSaveSignTokenCA.status !== 201) {
          yield put({
            type: request.response?.failed,
          });
        } else {
          yield put({
            type: request.response?.success,
          });
        }
      }
    }
  } catch (err) {
    console.log('error registertokenca', err);
    yield put({
      type: request.response?.failed,
      payload: [],
    });
  }
}

export function* watchRegisterTokenCA() {
  yield takeLatest(REGISTER_TOKENCA, doRegisterTokenCA);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/Account/RegisterTokenCA.ts